import styled, { keyframes } from 'styled-components';
const showAnimation = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;
const hideAnimation = keyframes`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;
export const Container = styled.div`
  position: relative;
  margin-top: 1em;
`;
export const Message = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  animation-duration: 0.4s;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
  animation-timing-function: linear;
  animation-name: ${({
  isVisible
}) => isVisible ? showAnimation : hideAnimation};
  color: ${({
  color
}) => color !== null && color !== void 0 ? color : 'inherit'};
`;